var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6162 6.2129C16.1822 5.8709 15.5542 5.9489 15.2132 6.3839L8.15821 15.3919L4.77921 11.1949C4.43121 10.7659 3.80321 10.6959 3.37321 11.0429C2.94221 11.3899 2.87521 12.0199 3.22021 12.4489L7.38921 17.6269C7.58021 17.8629 7.86621 17.9999 8.16921 17.9999H8.17621C8.48021 17.9979 8.76821 17.8569 8.95621 17.6159L16.7872 7.6159C17.1282 7.1819 17.0522 6.5529 16.6162 6.2129ZM21.6162 6.2129C21.1812 5.8709 20.5542 5.9489 20.2132 6.3839L13.1582 15.3919L12.5542 14.6429L11.2892 16.2599L12.3892 17.6269C12.5802 17.8629 12.8662 17.9999 13.1692 17.9999H13.1762C13.4802 17.9979 13.7682 17.8569 13.9562 17.6159L21.7872 7.6159C22.1282 7.1819 22.0522 6.5529 21.6162 6.2129ZM9.97991 11.4445L8.71291 13.0605L8.22091 12.4495C7.87491 12.0195 7.94191 11.3895 8.37291 11.0425C8.80391 10.6965 9.43291 10.7655 9.77891 11.1955L9.97991 11.4445Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDone);
export default __webpack_public_path__ + "static/media/all-done.d1e9ecea7ed8e86f8e48e837d1139d84.svg";
export { ForwardRef as ReactComponent };